export default __webpack_public_path__ + "static/media/11-61.59dad967.png";